// Keep Fit App - 前端入口
// React + TypeScript + TailwindCSS

import { useState, useEffect } from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';

// Pages
import Login from './pages/Login';
import Home from './pages/Home';
import Analyze from './pages/Analyze';
import Records from './pages/Records';
import Stats from './pages/Stats';
import Settings from './pages/Settings';

// Components
import Layout from './components/layout/Layout';

// Styles
import './index.css';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 5 * 60 * 1000,  // 5 分鐘
      retry: 2,
    },
  },
});

function App() {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [checking, setChecking] = useState(true);

  // 檢查登入狀態
  useEffect(() => {
    const auth = localStorage.getItem('keep-fit-auth');
    const loginTime = localStorage.getItem('keep-fit-login-time');
    
    if (auth === 'true' && loginTime) {
      // 檢查是否過期（24小時）
      const loginDate = new Date(loginTime);
      const now = new Date();
      const hoursDiff = (now.getTime() - loginDate.getTime()) / (1000 * 60 * 60);
      
      if (hoursDiff < 24) {
        setIsAuthenticated(true);
      } else {
        // 過期，清除登入狀態
        localStorage.removeItem('keep-fit-auth');
        localStorage.removeItem('keep-fit-login-time');
      }
    }
    setChecking(false);
  }, []);

  // 登入成功回調
  const handleLogin = () => {
    setIsAuthenticated(true);
  };

  // 登出
  const handleLogout = () => {
    localStorage.removeItem('keep-fit-auth');
    localStorage.removeItem('keep-fit-login-time');
    setIsAuthenticated(false);
  };

  // 載入中
  if (checking) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-50">
        <div className="text-center">
          <div className="text-4xl mb-4">🍎</div>
          <p className="text-gray-500">載入中...</p>
        </div>
      </div>
    );
  }

  // 未登入顯示登入頁面
  if (!isAuthenticated) {
    return <Login onLogin={handleLogin} />;
  }

  // 已登入顯示主應用
  return (
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <Layout onLogout={handleLogout}>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/analyze" element={<Analyze />} />
            <Route path="/records" element={<Records />} />
            <Route path="/stats" element={<Stats />} />
            <Route path="/settings" element={<Settings onLogout={handleLogout} />} />
          </Routes>
        </Layout>
      </BrowserRouter>
    </QueryClientProvider>
  );
}

export default App;
